import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import {
  featuresByRoleLibAsync,
  allFeaturesLibAsync,
  assignFeatureToRoleLibAsync,
  deleteFeatureLibAsync
} from 'src/redux/async/libraries/featureThunks';

const initialState = {
  allFeaturesData: [],
  roleFeatures: [],
  featureByRoleData:[],
  assignFeatureData:[],
  featureDeleteData: [],
  featureLoader: false,
  error: '',
  // featureAssignmentStatus: 'idle',
};

const featureSlice = createSlice({
  name: 'featureLibraries',
  initialState,
  reducers: {},
  extraReducers: (builder) => {

    // Fetch all features
      builder.addMatcher(isAnyOf(allFeaturesLibAsync.pending), (state) => {
        state.featureLoader = true
      })
      builder.addMatcher(isAnyOf(allFeaturesLibAsync.fulfilled), (state, action) => {
        state.featureLoader = false
        state.allFeaturesData = action.payload
        state.error = ''
      })
      builder.addMatcher(isAnyOf(allFeaturesLibAsync.rejected), (state, action) => {
        state.featureLoader = false
        state.error = action.payload
      })


    // Fetch features by role
      builder.addMatcher(isAnyOf(featuresByRoleLibAsync.pending), (state) => {
        state.featureLoader = true
      })
      builder.addMatcher(isAnyOf(featuresByRoleLibAsync.fulfilled), (state, action) => {
        state.featureLoader = false
        state.featureByRoleData = action.payload
        state.error = ''
      })
      builder.addMatcher(isAnyOf(featuresByRoleLibAsync.rejected), (state, action) => {
        state.featureLoader = false
        state.error = action.payload
      })


      // Assign feature to role
      builder.addMatcher(isAnyOf(assignFeatureToRoleLibAsync.pending), (state) => {
        state.featureLoader = true
      })
      builder.addMatcher(isAnyOf(assignFeatureToRoleLibAsync.fulfilled), (state, action) => {
        state.featureLoader = false
        state.assignFeatureData = action.payload
        state.error = ''
      })
      builder.addMatcher(isAnyOf(assignFeatureToRoleLibAsync.rejected), (state, action) => {
        state.featureLoader = false
        state.error = action.payload
      })

      // Delete feature will come under this
      builder.addMatcher(isAnyOf(deleteFeatureLibAsync.pending), (state) => {
        state.featureLoader = true
      })

      builder.addMatcher(isAnyOf(deleteFeatureLibAsync.fulfilled), (state, action) => {
        state.featureLoader = false
        state.featureDeleteData = action.payload
      })

      builder.addMatcher(isAnyOf(deleteFeatureLibAsync.rejected), (state, action) => {
        state.featureLoader = false
        state.error = action.payload
      })
  }
})

export default featureSlice.reducer
